module.exports = __webpack_public_path__ + "static/media/Rubyicon.0cb48d3e.png";